import { render, staticRenderFns } from "./GameSettings.vue?vue&type=template&id=507328ae&"
import script from "./GameSettings.vue?vue&type=script&lang=js&"
export * from "./GameSettings.vue?vue&type=script&lang=js&"
import style0 from "./GameSettings.vue?vue&type=style&index=0&id=507328ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports